<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
                    <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md6 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showUid"
              label='唯一标识'
              disabled
            />
          </div>

          <div class="flex md12 sm6 xs12">
            <va-select
              v-model="insertData.serviceType"
              label="课程类别"
              removable
              :options="serviceTypeOptions"
              :onchange="handleCourseTypeChange"
              :messages="message"
              :error="!!error.serviceTypeErrors.length"
              :error-messages="error.serviceTypeErrors"
            />
          </div>

          <div class="flex md6 sm6 xs12" v-show="!!insertData.serviceType">
            <va-input
              value='提示：不上传图片则会默认使用课程原有封面图'
              label=""
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="!!insertData.serviceType">
            <va-select
              v-model="insertData.serviceId"
              label="绑定课程名称"
              removable
              :onchange="handleCourseIdChange"
              :options="computedCourseIds"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='封面图'>
              <va-file-upload
                type='single'
                v-model='insertData.imgUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              :placeholder="placeholders.name"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="课程名称(英文)"
              :placeholder="placeholders.nameEn"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.serviceType!=='讲座/分享会'">
            <va-input
              v-model="insertData.description"
              :placeholder="placeholders.description"
              label="拼班描述"
              removable

            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.serviceType!=='讲座/分享会'">
            <va-input
              v-model="insertData.descriptionEn"
              :placeholder="placeholders.descriptionEn"
              label="拼班描述(英文)"
              removable
              success

            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.serviceType!=='讲座/分享会'">
            <va-input
              v-model="insertData.discount"
              :placeholder="placeholders.discount"
              label="折扣"
              removable

            />
          </div>
          <div class="flex md6 sm6 xs12" v-show="insertData.serviceType!=='讲座/分享会'">
            <va-input
              v-model="insertData.discountEn"
              :placeholder="placeholders.discountEn"
              label="折扣(英文)"
              removable
              success
            />
          </div>
          <div class="flex md4 sm6 xs12" v-show="insertData.serviceType!=='讲座/分享会'">
            <va-input
              v-model="insertData.releaseTime"
              label="开班时间"
              :placeholder="placeholders.releaseTime"
              removable
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.createTime"
              label="创建时间"
              disabled
              v-show="insertData.createTime"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import libaPreviewApi from '../../../api/libaPreview'
import { copyObject, formatTime, translateData } from '@/utils/common'
import {
  LIBA_PREVIEW_COURSE_TYPE,
  LIBA_PREVIEW_COURSE_TYPES,
  SERVICE_STATUS_TYPES,
} from '@/utils/constants'
import onlineActionApi from '@/api/onlineAction'
import jobCounselingApi from '@/api/jobCounseling'
import lectureApi from '@/api/lecture'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        name: '',
        nameEn: '',
        serviceType: '',
        serviceId: null,
        releaseTime: '',
        imgUrl: '',
        imgUrlArr: [],
        status: '草稿中',
        sortNum: 1,
        createTime: '',
        description: '',
        descriptionEn: '',
        discount: '',
        discountEn: '',
      },
      placeholders: {
        name: '例: 市场大数据分析',
        nameEn: 'ex: Market big data analysis',
        description: '例: 小班教学, 互相促进',
        descriptionEn: 'ex: Small class teaching, mutual promotion',
        discount: '例: 限时8折',
        discountEn: 'ex: 20% off for a limited time',
        releaseTime: '例: 7/28',
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        descriptionErrors: [],
        descriptionEnErrors: [],
        sortNumErrors: [],
        statusErrors: [],
        serviceTypeErrors: [],
        serviceIdErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      title: '新增篱笆预告',
      statusOptions: ['草稿中', '已发布', '已下架'],
      serviceIdOptions: [],
      serviceTypeOptions: LIBA_PREVIEW_COURSE_TYPES.map(x => { return x.TEXT }),
      serviceTypeMap: {},
      ServiceIdToName: {},
      serviceIdToImgUrl: {},
      submitButtonStatus: true,
      selectedServiceType: null,
      courses: [],
    }
  },
  created () {
    this.listCourse()
    this.getLibaPreview()
    this.initServiceTypeMap()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.serviceTypeErrors.length &&
          !this.error.serviceIdErrors.length &&
          !this.error.statusErrors.length
    },
    handleCourseTypeChange () {
      this.resetServiceId()
      this.listCourse()
      return true
    },
    handleCourseIdChange () {
      if (!this.insertData.serviceId) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.insertData.imgUrl = ''
      } else {
        const id = this.flipCourseIds[this.insertData.serviceId]
        if (id && this.serviceIdToImgUrl[id]) {
          this.insertData.imgUrl = this.serviceIdToImgUrl[id]
        }
      }
      return true
    },
    computedCourseIds () {
      return this.courses.map(x => {
        return x.name + '(' + x.id + ')'
      })
    },
    flipCourseIds () {
      const flipCourseIds = {}
      this.courses.forEach(x => {
        flipCourseIds[x.name + '(' + x.id + ')'] = x.id
      })
      return flipCourseIds
    },
  },
  methods: {
    getLibaPreview () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.showUid = true
        this.showViews = true
        this.title = '编辑篱笆预告'
        // 通过id获取详情
        libaPreviewApi.getLibaPreview(params.id).then(response => {
          copyObject(response.libaPreview, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.libaPreview.hasOwnProperty('status')) {
            SERVICE_STATUS_TYPES.map(x => {
              if (response.libaPreview.status === x.CODE) {
                this.insertData.status = x.TEXT
              }
            })
          }
          LIBA_PREVIEW_COURSE_TYPES.forEach(x => {
            if (x.CODE === response.libaPreview.serviceType) {
              this.insertData.serviceType = x.TEXT
            }
          })
          this.insertData.serviceId = response.libaPreview.course.name + '(' + response.libaPreview.course.id + ')'
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        courseId: this.insertData.courseId,
        views: this.insertData.views,
        imgUrl: this.insertData.imgUrl,
        releaseTime: this.insertData.releaseTime,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
        discount: this.insertData.discount,
        discountEn: this.insertData.discount,
        description: this.insertData.descriptionEn,
        descriptionEn: this.insertData.descriptionEn,
      }
      data.serviceType = this.serviceTypeMap[this.insertData.serviceType]
      data.serviceId = this.flipCourseIds[this.insertData.serviceId]
      SERVICE_STATUS_TYPES.map(x => {
        if (x.TEXT === this.insertData.status) {
          data.status = x.CODE
        }
      })
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        libaPreviewApi.updateLibaPreview(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新篱笆预告成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listLibaPreview' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        if (!data.imgUrl) {
          data.imgUrl = this.serviceIdToImgUrl[data.serviceId]
        }
        libaPreviewApi.saveLibaPreview(data).then(response => {
          if (response.success === true) {
            this.showToast('保存篱笆预告成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listLibaPreview' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.serviceIdErrors = this.insertData.serviceId ? [] : ['serviceId is required']
      this.error.serviceTypeErrors = this.insertData.serviceType ? [] : ['serviceType is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    uploadImage () {
      if (this.insertData.imgUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.imgUrlArr[this.insertData.imgUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    initServiceTypeMap () {
      LIBA_PREVIEW_COURSE_TYPES.map(x => {
        this.serviceTypeMap[x.TEXT] = x.CODE
      })
    },
    resetServiceId () {
    },
    listCourse () {
      this.ServiceIdToName = {}
      this.serviceIdToImgUrl = {}
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      const serviceType = this.serviceTypeMap[this.insertData.serviceType]
      if (serviceType === LIBA_PREVIEW_COURSE_TYPE.ONLINE_ACTION.CODE) {
        onlineActionApi.listOnlineAction(params).then(response => {
          this.courses = response.onlineActions
          this.courses.forEach(x => {
            this.ServiceIdToName[x.id] = x.name
            this.serviceIdToImgUrl[x.id] = x.imgUrl
          })
        })
      }
      if (serviceType === LIBA_PREVIEW_COURSE_TYPE.JOB_COUNSELING.CODE) {
        jobCounselingApi.listJobCounseling(params).then(response => {
          this.courses = response.jobCounselings
          this.courses.forEach(x => {
            this.ServiceIdToName[x.id] = x.name
            this.serviceIdToImgUrl[x.id] = x.imgUrl
          })
        })
      }
      if (serviceType === LIBA_PREVIEW_COURSE_TYPE.LECTURE.CODE) {
        lectureApi.listLecture(params).then(response => {
          this.courses = response.lectures
          this.courses.forEach(x => {
            this.ServiceIdToName[x.id] = x.name
            this.serviceIdToImgUrl[x.id] = x.imgUrl
          })
        })
      }
    },
    async translateUnfilledFields () {
      // 课程标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
      // 课程介绍
      if (this.insertData.description !== '' && this.insertData.descriptionEn === '') {
        this.insertData.descriptionEn = await translateData(this.insertData.description)
      }
      // 折扣
      if (this.insertData.discount !== '' && this.insertData.discountEn === '') {
        this.insertData.discountEn = await translateData(this.insertData.discount)
      }
    },

  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
